import React from 'react'
import '../../Style.css';
import '../../Media-styles.css';

import '../Styles/ProGrid.css'

import Slider from './Slider';

import ProjectFeatures from '../../../components/Project-Series/Project2/Features';



function ProjectTwo() {
    return (
        <>



            <div className='inner_container'>


                <div className='pro-inner-body-container'>
                    <div className='inner_body'>
                        <section className="section-container">

                            <div className="section-body">
                                <div className="section-left">
                                    
                                    <Slider />


                                </div>

                                <div className="section-right-wht">
                                   
                                    
                                    <h2 className="product-feature">
                                    HBF Arena - Joondalup
                                    </h2>

                                    <ProjectFeatures />

                                </div>
                            </div>
                           
                        </section>

                    </div>

                </div>
            </div>

        
        </>
    )
}

export default ProjectTwo;
